import React from "react";
import { Route, Switch } from "react-router-dom";
import Addon from "./Addon";
import FreeNavbar from "./FreeNavbar";
import Landing from "./Landing";
import styles from "./FreeRoot.module.scss";

const FreeRoot: React.FC = () => {
    return (
        <>
            <FreeNavbar />
            <div className={styles.content}>
                <Switch>
                    <Route exact={true} path="*/addon">
                        <Addon />
                    </Route>
                    <Route>
                        <Landing />
                    </Route>
                </Switch>
            </div>
        </>
    );
};

export default FreeRoot;
